export class StringUtils {

  static isString(input: any): boolean {
    return input != null;
  }

}
